import React, { ReactElement, useCallback } from 'react';
import { DocumentProps, pdf } from '@react-pdf/renderer';
import FileSaver from 'file-saver';

interface IPdfExport {
	/**
	 * name of the file to be created
	 */
	filename: string;
	/**
	 * callback function that retrieves and regenreated the react-pdf element
	 */
	getPdfElement: () => ReactElement<DocumentProps, string> | null;
}

const usePdfExport = (props: IPdfExport) => {
	const { filename, getPdfElement } = props;
	const [isGenerating, setIsGenerating] = React.useState(false);

	const generatePdf = useCallback(async () => {
		setIsGenerating(true);

		const pdfDocument = getPdfElement();

		if (!pdfDocument) {
			throw new Error('Attempted to generate a pdf with a missing document');
		}

		// generated pdf with react pdf and store as blob
		const blob = await pdf(pdfDocument).toBlob();

		FileSaver.saveAs(blob, filename);

		setIsGenerating(false);
	}, [filename, getPdfElement]);

	return {
		isGenerating,
		generatePdf,
	};
};

export default usePdfExport;
